import { Carousel } from "react-responsive-carousel";
import Modal from "../components/Modal";
import { useState } from "react";
import { GetInTouch } from "../components/GetInTouch";

export default function NewTransitCourier() {
  const model = "Transit Courier Април 2026";
  const copy = "raya.dacheva@motopfohe.bg";
  const conversionSendTo = "AW-17814485194/HOcACLil1d0bEMrxza5C";
  document.title = "Новият Ford Transit Courier";

  const [showModal, setShowModal] = useState(false);
  const [zapitvane, setZapitvane] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    setZapitvane(false);
  };

  return (
    <div className="font-fordAntennaRegular">
      <section className="relative">
        <img
          src="../images/transit-courier/transit-courier-desktop.jpg"
          alt="Ford Transit Courier"
          className="hidden w-full lg:block"
        />
        <img
          src="../images/transit-courier/transit-courier-mobile.jpeg"
          alt="Ford Transit Courier"
          className="block w-full lg:hidden"
        />
        <div className="absolute inset-x-0 bottom-0 flex justify-center p-6 text-center lg:inset-x-auto lg:bottom-auto lg:left-4 lg:top-4 lg:max-w-xl lg:justify-start lg:p-0 lg:text-left">
          <div className="rounded-2xl bg-black/45 px-5 py-4 text-white backdrop-blur-[2px] lg:px-6 lg:py-5">
            <p className="text-sm tracking-wider uppercase font-fordMedium lg:text-lg">
              Ford Transit Courier с много екстри*
            </p>
            <h1 className="mt-3 text-2xl leading-[1.05] uppercase font-fordBlack lg:text-4xl">
              Сега на супер цена
              <br />
              <span className="text-lg">от</span> 17 700{" "}
              <span className="text-2xl">€</span> / 34 618,19{" "}
              <span className="text-2xl">лв.</span>
              <br />
              <span className="block -mt-0.5 text-lg font-fordMedium">
                без ДДС
              </span>
            </h1>
          </div>
        </div>
      </section>
      <section className="p-4 lg:p-12 lg:px-36">
        <p className="mt-8 text-2xl leading-8 tracking-wide text-center lg:text-5xl font-fordBlack text-fordBlue">
          ИЗЦЯЛО НОВИЯТ FORD TRANSIT COURIER
        </p>
        <p className="mt-4 text-2xl leading-8 tracking-wide text-center text-fordBlue">
          Повече пространство за разрастване на бизнеса ви.
        </p>
        <div className="flex flex-col items-center justify-center gap-8 mt-8 lg:gap-12 lg:flex-row">
          <button
            className="px-12 py-2 border rounded-full border-fordBlue text-fordBlue hover:bg-fordBlue hover:text-white"
            onClick={() => {
              setShowModal(true);
              setZapitvane(true);
              window.scrollTo(0, 0);
            }}
          >
            Свържи се с търговец
          </button>
          <a
            href="https://sale.ford.bg/?model=Courier&fuel=%D0%91%D0%B5%D0%BD%D0%B7%D0%B8%D0%BD"
            rel="noreferrer"
          >
            <button className="px-12 py-2 border rounded-full border-fordBlue text-fordBlue hover:bg-fordBlue hover:text-white">
              Налични автомобили
            </button>
          </a>
        </div>
      </section>
      <section className="p-8 lg:p-12 lg:px-64 bg-fordBlue">
        <p className="text-lg text-center text-white">
          Все още компактен отвън, новият Transit Courier вече е по-дълъг,
          по-широк и по-висок. Освен това е и по-интелигентен. Освен че сме
          направили място за два европалета, ние сме повишили нивото с
          усъвършенствани възможности за свързване, сигурност и технологии.
        </p>
      </section>
      <section>
        <div className="flex flex-col mx-4 my-16 lg:m-16 lg:flex-row">
          <img
            src="../images/new-transit-courier/ford-transit-courier-volume.jpg"
            alt=""
            className="rounded-xl lg:w-1/2"
          />
          <div className="p-4 lg:p-16 lg:w-1/2">
            <h3 className="text-5xl tracking-wide text-fordBlue">Oбем</h3>
            <p className="mt-4 text-md text-fordBlue">
              Дължината на товарния отсек от 1,8 м, с разстояние между арките на
              колелата от 1,22 м, е проектирана така, че да побира два
              европалета и максимален полезен товар от 820 кг. Повишаването на
              височината на тавана до 1,25 м допринася за големия обем.
              E-Transit Courier дори разполага с допълнително 50 л достъпно
              място за съхранение в предния багажник.
            </p>
          </div>
        </div>
        <div className="flex flex-col-reverse mx-4 lg:mx-16 lg:flex-row">
          <div className="p-4 lg:p-16 lg:w-1/2 ">
            <h3 className="text-5xl tracking-wide text-fordBlue">Свързаност</h3>
            <p className="mt-4 text-md text-fordBlue">
              Transit Courier е оборудван с най-новата система SYNC 4 с 8" или
              12" сензорен екран, изцяло свързан с мобилно устройство, системи
              за подпомагане на водача и информация за състоянието на автомобила
            </p>
          </div>
          <img
            src="../images/new-transit-courier/ford-transit-courier-connectivity.jpg"
            alt=""
            className="lg:w-1/2 rounded-xl"
          />
        </div>
        <div className="flex flex-col mx-4 mt-16 lg:m-16 lg:flex-row">
          <img
            src="../images/transit-courier/Transit_Courier_Cactus_Grey_Interior.webp"
            alt=""
            className="lg:w-1/2 rounded-xl"
          />
          <div className="p-4 lg:p-16 lg:w-1/2 bg-gray-50">
            <h3 className="text-5xl tracking-wide text-fordBlue">
              Помощ при управление
            </h3>
            <p className="mt-4 text-md text-fordBlue">
              Transit Courier е снабден с усъвършенствани системи, които ви
              помагат в работния ден. Интелигентните системи за подпомагане на
              шофирането, включително адаптивен круиз контрол с поддържане на
              лентата за движение, асистент за предотвратяване на сблъсък,
              интелигентен асистент за намаляване на скоростта и асистент за
              паркиране - правят шофирането и работата по-лесни, по-интелигентни
              и по-безопасни.
            </p>
          </div>
        </div>
      </section>
      {/* <section className="p-8 lg:p-12 lg:px-36 bg-fordBlue">
        <p className="text-2xl text-center text-white font-fordMedium">
          Задава се революционно решение за всички нужди на бизнеса – Новият
          Transit Courier!
          <br />
          Безкомпромисни възможности, издръжливост и продуктивност.
        </p>
      </section> */}
      <section className="flex flex-col items-center px-4 py-12 lg:justify-center lg:p-16 lg:flex-row">
        <a
          href="https://ford.bg/commercial_cars/new-transit-courier"
          target="_blank"
        >
          <button className="px-12 py-2 mx-8 border rounded-full border-fordBlue text-fordBlue hover:bg-fordBlue hover:text-white">
            Виж повече за модела
          </button>
        </a>
        <button
          className="px-12 py-2 mx-8 mt-8 border rounded-full lg:mt-auto border-fordBlue text-fordBlue hover:bg-fordBlue hover:text-white"
          onClick={() => {
            setShowModal(true);
            setZapitvane(true);
            window.scrollTo(0, 0);
          }}
        >
          Свържи се с търговец
        </button>
      </section>
      {/* <img
        src="./images/new-transit-courier/ford-transit-courier-front-grill.jpg"
        alt=""
      /> */}
      <section className="p-4 -mb-8 lg:px-24">
        <p className="text-sm text-gray-500">
          * Специалната цена е валидна за юридически лица и се отнася за модел
          Transit Courier Van Trend, в ограничен брой налични автомобили на
          склад към 27.04.2026. Офертата включва следното оборудване: увеличен
          полезен товар до 820 кг, каучуково покритие на товарния под, LED
          осветление в товарното отделение и 16“ стоманено резервно колело.
          Промоцията е валидна до 29.05.2026 г. или до изчерпване на
          наличностите. Изображенията са илюстративни.
        </p>
      </section>
      {showModal && zapitvane && (
        <Modal handleClose={handleClose}>
          <GetInTouch
            model={model}
            copy={copy}
            conversionSendTo={conversionSendTo}
          />
        </Modal>
      )}
    </div>
  );
}
